import React, { Component } from "react";
import InputMask from "react-input-mask";

import API from "../../../actions/api-helper";
import DataUtil from "../../../actions/data.js";

import { withRouter } from 'react-router-dom';
import UI from "../../../actions/ui-helper";

class Apuracao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        periodoDe: DataUtil.primeiroDiaMes(),
        periodoAte: DataUtil.ultimoDiaMes(),
        profissionalId: this.props.usuario.perfil === 2 ? this.props.usuario.id : 0,
        formato: this.props.usuario.perfil < 2 ? 1 : 3
      },
      usuarios: [],
      resultado: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    UI.loader("show", "Aguarde, buscando profissionais...");
    API.get("/usuarios/ativos").then(
      function (json) {
        // Cria uma lista simplificada de usuários
        let usuarios = [{ id: 0, nome: "TODOS" }];
        json.data.forEach(usuario => {
          usuarios.push({
            id: usuario.id,
            nome: usuario.nome
          });
        });
        this.setState({ usuarios: usuarios });
        UI.loader("hide");
      }.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();

    let data = this.state.consulta;
    if (!DataUtil.validarData(data.periodoDe) || !DataUtil.validarData(data.periodoAte)) {
      data.periodoDe = DataUtil.primeiroDiaMes();
      data.periodoAte = DataUtil.ultimoDiaMes();
    }

    if (parseInt(data.formato) === 3) {
      data.formato = 2;
      this.props.history.push("/impressao/resumo", this.state.consulta);
    }
    else {
      this.props.history.push("/impressao/apuracao", this.state.consulta);
    }
  }

  handleChange(event) {
    let consulta = { ...this.state.consulta };
    consulta[event.target.name] = event.target.value;
    this.setState({ consulta: consulta });
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">APURAÇÃO POR PERÍODO</h4>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group row">
                      <div className="col-md-3">
                        <label>Período De</label>
                        <InputMask
                          placeholder="PERÍODO DE"
                          name="periodoDe"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoDe}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Período Até</label>
                        <InputMask
                          placeholder="PERÍODO ATÉ"
                          name="periodoAte"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoAte}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>Profissional</label>
                        <select
                          name="profissionalId"
                          className="form-control"
                          value={this.state.consulta.profissionalId}
                          onChange={this.handleChange}
                        >
                          {this.state.usuarios.map(
                            (usuario, i) => {
                              if (this.props.usuario.perfil <= 1 || this.props.usuario.id === usuario.id) {
                                return (
                                  <option key={usuario.id} value={usuario.id}>
                                    {usuario.nome}
                                  </option>
                                );
                              }
                              return null;
                            }
                          )}
                        </select>
                      </div>
                      <div className="col-sm-3">
                        <label>Formato</label>
                        <select
                          name="formato"
                          className="form-control"
                          value={this.state.consulta.formato}
                          onChange={this.handleChange}
                        >
                          {this.props.usuario.perfil <= 1 && <option value={1}>RECEBIMENTO (CISMEPAR)</option>}
                          {this.props.usuario.perfil <= 1 && <option value={2}>PAGAMENTO (DETALHADO)</option>}
                          <option value={3}>PAGAMENTO (RESUMIDO)</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 text-right">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-2"
                        >
                          Gerar Relatório
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form >
    );
  }
}

export default withRouter(Apuracao);
